/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Cue_2Inputs */

const en_us2_workout_cue_2 = /** @type {(inputs: Workout_Cue_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sip of water now helps the next set.`)
};

const pt_br2_workout_cue_2 = /** @type {(inputs: Workout_Cue_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um gole de água agora ajuda na próxima série.`)
};

const es_419_workout_cue_2 = /** @type {(inputs: Workout_Cue_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un trago de agua ahora ayuda en la siguiente serie.`)
};

const pt_pt2_workout_cue_2 = /** @type {(inputs: Workout_Cue_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um gole de água agora ajuda na próxima série.`)
};

const fr_fr2_workout_cue_2 = /** @type {(inputs: Workout_Cue_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une gorgée d'eau maintenant aide pour la série suivante.`)
};

const de_de2_workout_cue_2 = /** @type {(inputs: Workout_Cue_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Schluck Wasser jetzt hilft beim nächsten Satz.`)
};

const it_it2_workout_cue_2 = /** @type {(inputs: Workout_Cue_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un sorso d'acqua adesso aiuta la prossima serie.`)
};

/**
* | output |
* | --- |
* | "A sip of water now helps the next set." |
*
* @param {Workout_Cue_2Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_cue_2 = /** @type {((inputs?: Workout_Cue_2Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Cue_2Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_cue_2(inputs)
	if (locale === "es-419") return es_419_workout_cue_2(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_cue_2(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_cue_2(inputs)
	if (locale === "de-DE") return de_de2_workout_cue_2(inputs)
	if (locale === "it-IT") return it_it2_workout_cue_2(inputs)
	return en_us2_workout_cue_2(inputs)
});
export { workout_cue_2 as "workout.cue_2" }